import { handleActions } from "redux-actions";

import removeById from "utils/removeById";

const assetUsersReducer = handleActions(
  {
    ASSET_USERS_GET: {
      PENDING: () => ({
        assetUsers: [],
      }),
      FULFILLED: (state, action) => ({
        assetUsers: action.payload.users,
      }),
    },
    ASSET_USER_REMOVE: {
      FULFILLED: (state, action) => ({
        assetUsers: removeById(state.assetUsers, action.meta.userId),
      }),
    },
    USER_INVITE: {
      FULFILLED: (state, action) => ({
        assetUsers: [...state.assetUsers, action.payload.user],
      }),
    },
    ASSET_COMPANY_REMOVE: {
      FULFILLED: (state, action) => ({
        assetUsers: state.assetUsers.filter(
          (user) => user.company.id !== parseInt(action.meta.companyId, 10)
        ),
      }),
    },
  },
  {},
  { namespace: "_" }
);
export default assetUsersReducer;
